<template>
  <div class="bitacora">
    <b-row>
      <b-col>
        <logs-list></logs-list>
      </b-col>
    </b-row>

    <!-- SPACER-->
    <spacer-card></spacer-card>
    <!-- SPACER-->

    <b-row>
      <b-col>
        <div class="accordion">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button
                class="accordion-button"
                :class="debugHidden? '':'collapsed'"
                type="button"
                @click="cambiarAcordion"
              >
                <span>{{debugHidden? 'Mostrar datagramas de depuración':'Ocultar datagramas de depuración'}}</span>
              </button>
            </h2>
            <div
              class="accordion-collapse" id="acordion-content" :hidden="debugHidden"
            >
              <div class="accordion-body">
                <datagrams-debug-list></datagrams-debug-list>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- SPACER-->
    <spacer-card></spacer-card>
    <!-- SPACER-->

    <b-row>
      <b-col>
        <datagrams-list></datagrams-list>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/*
refs, and $refs, are not reactive.

If you want to pick up the updated value, you should wait until
the next render cycle updates the DOM.

*/

import Datagramslist from "@/components/datagrams/DatagramsList.vue";
import DatagramsDebugList from "@/components/datagrams/DatagramsDebugList.vue";
import Logslist from "@/components/logs/LogsList.vue";
import Spacer from "@/components/card/Spacer";



export default {
  data() {
    return {
      debugHidden: true
    };
  },
  components: {
    "datagrams-list": Datagramslist,
    "datagrams-debug-list": DatagramsDebugList,
    "logs-list": Logslist,
    "spacer-card": Spacer,
  },
  methods: {
    cambiarAcordion(){
      this.debugHidden = !this.debugHidden;
    }
  }
};
</script>

<style>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
